// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  baseUrl : 'https://profidev.quickinfo.dk',
  mainUrl: 'https://profidevapi.quickinfo.dk',
  production: false,
  appTokenKey: '_p_u_t_',
  apiUrl: 'https://profidevapi.quickinfo.dk/api',
  azureUrl : 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?client_id=04c1fac1-B24f-4bb5-8980-C204bc9d3d02&response_type=code&redirect_uri=https%3A%2F%2Fprofidevapi.quickinfo.dk%2Fapi%2Fazure-ad%2Fcallback&scope=openid+User.Read&state=login&prompt=login',
  azureUrlUnpublished : 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?client_id=04c1fac1-b24f-4bb5-8980-c204bc9d3d02&response_type=code&redirect_uri=https%3A%2F%2Fprofidevapi.quickinfo.dk%2Fapi%2Fazure-ad%2Fcallback&scope=openid+User.Read&state=unpublished&prompt=login',
  azureUrlArchive : 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?client_id=04c1fac1-b24f-4bb5-8980-c204bc9d3d02&response_type=code&redirect_uri=https%3A%2F%2Fprofidevapi.quickinfo.dk%2Fapi%2Fazure-ad%2Fcallback&scope=openid+User.Read&state=archive&prompt=login',
  appVersion: require('../../package.json').version,
  showSection : true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
